// eslint-disable-next-line no-restricted-imports
import { State } from 'app/gamma/src/modules/types';
// eslint-disable-next-line no-restricted-imports
import { CardModel } from 'app/gamma/src/types/models';

export const getCardById = (
  state: State,
  idCard: string,
): CardModel | undefined =>
  state.models.cards.find((card: CardModel) => card.id === idCard);
